
import { getUserFields } from "components/user/config";
import { getItemFromCollection } from "directus/src/operations";

export async function fetchReceivedReview({ reviewId }) {
  try {
    const query = {
      fields: [getUserFields("reviewee"), getUserFields("reviewer"), "*"],
    };
    const response = await getItemFromCollection(
      "performance_review",
      reviewId,
      query
    );
    return response;
  } catch (error) {
    return error;
  }
}
